export const translations = {
  en: {
    nav: {
      home: "Home",
      lakes: "Lakes",
      catches: "Catches",
      rules: "Rules & Tips",
      booking: "Booking",
      events: "Events",
      admin: "Admin",
      login: "Sign in",
      logout: "Sign out",
      register: "Create account",
      myBookings: "My bookings",
      account: "Account",
    },
    home: {
      tagline: "Two lakes. One quiet corner of Hungary.",
      title_1: "A fishing & relax",
      title_2: "retreat in Dég",
      intro: "Owned and tended for over twenty years, our two lakes near Dég offer trophy carp, rustic cabins and unhurried mornings. Welcome to Dég Dusk.",
      cta_book: "Book a swim or cabin",
      cta_catches: "See recent catches",
      stats_lakes: "Lakes",
      stats_spots: "Fishing swims",
      stats_houses: "Cabins",
      stats_species: "Fish species",
      featured_lakes: "Two Lakes",
      featured_lakes_sub: "Each lake has its own character. Pick the mood that suits the trip.",
      featured_catches: "Latest catches",
      featured_catches_sub: "Real catches submitted by anglers staying with us.",
      view_all: "View all",
      season: "Season is open year-round",
      hero_cta_label: "Plan your stay",
    },
    lakes: {
      heading: "The Lakes",
      sub: "Information, fish species and depth profiles for our two waters.",
      area: "Area",
      depth: "Max depth",
      species: "Resident species",
      hectares: "hectares",
      meters: "meters",
    },
    catches: {
      heading: "Catches",
      sub: "Live catch book — submit your catch from the lakeside.",
      leaderboard: "Leaderboard",
      gallery: "Catch gallery",
      submit: "Submit a catch",
      login_required: "Sign in to log your catch",
      no_catches: "No catches yet — be the first to submit one.",
      total_weight: "Total weight",
      biggest: "Biggest",
      count: "Catches",
      by: "by",
      weight: "Weight",
      length: "Length",
      species: "Species",
      spot: "Swim / Spot",
      notes: "Notes",
      caught_at: "Caught at",
      photo: "Photo of the fish",
      submit_button: "Submit catch",
      success: "Catch logged. Tight lines!",
    },
    rules: {
      heading: "Rules & Advice",
      sub: "How we keep the lakes beautiful — and how to fish them well.",
      rules: "Lake rules",
      advice: "Seasonal advice",
    },
    booking: {
      heading: "Book a swim or cabin",
      sub: "Pick a date range and see real-time availability.",
      tabs_spots: "Fishing swims",
      tabs_houses: "Cabins",
      from: "From",
      until: "Until",
      guests: "Guests",
      notes: "Notes for host",
      per_night: "/ night",
      total: "Total",
      nights: "nights",
      capacity: "Capacity",
      amenities: "Amenities",
      reserve: "Reserve & pay",
      reserve_only: "Reserve",
      login_required: "Sign in to make a booking",
      pick_dates: "Select your dates",
      booked_dates: "Booked dates",
      available: "Available",
      booked: "Reserved",
      success: "Booking created",
      reservation_only: "Reservation confirmed. Pay on arrival.",
    },
    events: {
      heading: "Events",
      sub: "Tournaments, family weekends and seasonal gatherings.",
      no_events: "No upcoming events.",
      when: "When",
      where: "Where",
    },
    admin: {
      heading: "Admin",
      sub: "Manage lake content, swims, cabins, catches and bookings.",
      tabs: {
        stats: "Overview",
        lakes: "Lakes",
        items: "Swims & Cabins",
        catches: "Catches",
        bookings: "Bookings",
        events: "Events",
        rules: "Rules",
        users: "Users",
      },
      save: "Save",
      add: "Add new",
      edit: "Edit",
      delete: "Delete",
      cancel: "Cancel",
    },
    auth: {
      login_title: "Welcome back",
      login_sub: "Sign in to log catches and book your stay.",
      register_title: "Create an account",
      register_sub: "Join the Dég Dusk community.",
      email: "Email",
      password: "Password",
      name: "Name",
      sign_in: "Sign in",
      sign_up: "Create account",
      no_account: "No account yet?",
      have_account: "Already have an account?",
    },
    footer: {
      tagline: "Dég Dusk — fishing & relax",
      address_label: "Address",
      address: "Dég, 8135 Hungary",
      phone_label: "Emergency",
      hours_label: "Open all year",
      social_label: "Follow us",
      copyright: "© 2026 Dég Lakes Resort. All rights reserved.",
    },
    common: {
      loading: "Loading…",
      save: "Save",
      cancel: "Cancel",
      submit: "Submit",
      back: "Back",
      kg: "kg",
      cm: "cm",
      currency: "€",
    },
  },
  hu: {
    nav: {
      home: "Főoldal",
      lakes: "Tavak",
      catches: "Fogások",
      rules: "Szabályok & Tippek",
      booking: "Foglalás",
      events: "Események",
      admin: "Admin",
      login: "Bejelentkezés",
      logout: "Kijelentkezés",
      register: "Regisztráció",
      myBookings: "Foglalásaim",
      account: "Profil",
    },
    home: {
      tagline: "Két tó. Egy csendes magyar zug.",
      title_1: "Horgász és pihenő",
      title_2: "rezort Dégen",
      intro: "Több mint húsz éve gondozott két tavunk Dég mellett trófea pontyot, rusztikus faházakat és nyugodt reggeleket kínál. Üdvözlünk a Dég Dusknál.",
      cta_book: "Helyet vagy faházat foglalok",
      cta_catches: "Legutóbbi fogások",
      stats_lakes: "Tó",
      stats_spots: "Horgászhely",
      stats_houses: "Faház",
      stats_species: "Halfaj",
      featured_lakes: "A Két Tó",
      featured_lakes_sub: "Mindkét tónak megvan a saját karaktere. Válaszd ki a hangulatot.",
      featured_catches: "Friss fogások",
      featured_catches_sub: "Vendégeink valódi fogásai.",
      view_all: "Mind",
      season: "Egész évben nyitva",
      hero_cta_label: "Tervezd meg a látogatásod",
    },
    lakes: {
      heading: "A Tavak",
      sub: "Információk, halfajok és mélységi profilok a két tavunkról.",
      area: "Vízfelület",
      depth: "Max. mélység",
      species: "Halfajok",
      hectares: "hektár",
      meters: "méter",
    },
    catches: {
      heading: "Fogások",
      sub: "Élő fogásnapló — rögzítsd a fogásod a tópartról.",
      leaderboard: "Ranglista",
      gallery: "Fogás galéria",
      submit: "Fogás rögzítése",
      login_required: "Jelentkezz be a fogás rögzítéséhez",
      no_catches: "Még nincs fogás — legyél az első!",
      total_weight: "Összsúly",
      biggest: "Legnagyobb",
      count: "Fogások",
      by: "—",
      weight: "Súly",
      length: "Hossz",
      species: "Halfaj",
      spot: "Hely",
      notes: "Megjegyzés",
      caught_at: "Fogás ideje",
      photo: "A hal fotója",
      submit_button: "Fogás rögzítése",
      success: "Fogás rögzítve. Tight lines!",
    },
    rules: {
      heading: "Szabályok és Tanácsok",
      sub: "Így vigyázunk a tavakra — és így horgászd őket eredményesen.",
      rules: "Tószabályok",
      advice: "Szezonális tanácsok",
    },
    booking: {
      heading: "Helyet vagy faházat foglalok",
      sub: "Válassz dátumot és nézd valós időben a szabad helyeket.",
      tabs_spots: "Horgászhelyek",
      tabs_houses: "Faházak",
      from: "Tól",
      until: "Ig",
      guests: "Fő",
      notes: "Megjegyzés a házigazdának",
      per_night: "/ éj",
      total: "Összesen",
      nights: "éj",
      capacity: "Kapacitás",
      amenities: "Szolgáltatások",
      reserve: "Foglalás & fizetés",
      reserve_only: "Foglalás",
      login_required: "Foglaláshoz jelentkezz be",
      pick_dates: "Válassz dátumot",
      booked_dates: "Foglalt napok",
      available: "Szabad",
      booked: "Foglalt",
      success: "Foglalás létrehozva",
      reservation_only: "Foglalás megerősítve. Fizetés érkezéskor.",
    },
    events: {
      heading: "Események",
      sub: "Versenyek, családi hétvégék, szezonális találkozók.",
      no_events: "Nincs közelgő esemény.",
      when: "Mikor",
      where: "Hol",
    },
    admin: {
      heading: "Admin",
      sub: "Tavak, horgászhelyek, faházak, fogások és foglalások kezelése.",
      tabs: {
        stats: "Áttekintés",
        lakes: "Tavak",
        items: "Helyek & Faházak",
        catches: "Fogások",
        bookings: "Foglalások",
        events: "Események",
        rules: "Szabályok",
        users: "Felhasználók",
      },
      save: "Mentés",
      add: "Új hozzáadása",
      edit: "Szerkesztés",
      delete: "Törlés",
      cancel: "Mégse",
    },
    auth: {
      login_title: "Üdv újra!",
      login_sub: "Jelentkezz be fogás rögzítéséhez és foglaláshoz.",
      register_title: "Regisztrálj",
      register_sub: "Csatlakozz a Dég Dusk közösséghez.",
      email: "Email",
      password: "Jelszó",
      name: "Név",
      sign_in: "Bejelentkezés",
      sign_up: "Regisztráció",
      no_account: "Nincs még fiókod?",
      have_account: "Van már fiókod?",
    },
    footer: {
      tagline: "Dég Dusk — horgász & pihenő",
      address_label: "Cím",
      address: "Dég, 8135 Magyarország",
      phone_label: "Vészhelyzet",
      hours_label: "Egész évben nyitva",
      social_label: "Kövess minket",
      copyright: "© 2026 Dég Lakes Resort. Minden jog fenntartva.",
    },
    common: {
      loading: "Töltés…",
      save: "Mentés",
      cancel: "Mégse",
      submit: "Beküldés",
      back: "Vissza",
      kg: "kg",
      cm: "cm",
      currency: "€",
    },
  },
};
